import React from "react";
import styles from "./VisaStepBar.module.css";
/**
 * props:
 * - total: número total de perguntas aplicáveis
 * - currentIndex: índice (0-based) da pergunta atual entre as aplicáveis
 */
export default function DotSteps({ total, currentIndex }) {
  const arr = Array.from({ length: total });
  return (
    <div className={styles.wrap}>
      {arr.map((_, i) => (
        <div
          key={i}
          className={`${styles.dot} ${i < currentIndex ? styles.done : ""} ${i === currentIndex ? styles.active : ""}`}
        />
      ))}
    </div>
  );
}
